import type { EmailTemplate } from '@/pages/sidebar/SettingsPage/types';

export interface EmailTemplateWithRef extends EmailTemplate {
  templateRef: string;
}

export const AI_RESPONSE_FALLBACK_TEMPLATE_ID = 'et-3';

export const AI_RESPONSE_FALLBACK_SUBJECT = 'Thanks for reaching out!';

export const AI_RESPONSE_FALLBACK_MESSAGE = `Hi {{client_name}},

Thank you for reaching out and for sharing details about your event.

I received your message and will follow up shortly with availability and next steps.

Best regards,`;

export const DEFAULT_EMAIL_TEMPLATES: EmailTemplateWithRef[] = [
  {
    id: 'et-1',
    templateRef: 'templates/email/contract-email-template.txt',
    name: 'Contract email template',
    subject: 'Your online contract is ready',
    message: `Dear {{client_name}},

This is a courtesy message to let you know your contract is ready to view and sign electronically online.

Please view and sign your contract online by clicking here

If you have any questions, please don't hesitate to contact me.

Regards`,
  },
  {
    id: 'et-2',
    templateRef: 'templates/email/quote-ready-template.txt',
    name: 'Quote ready template',
    subject: 'Your quote is ready to view',
    message: `Dear {{client_name}},

Thank you for your enquiry. Please find attached your quote for our services.

Please view your quote online by clicking here

If you have any questions, please don't hesitate to contact me.

Regards`,
  },
  {
    id: AI_RESPONSE_FALLBACK_TEMPLATE_ID,
    templateRef: 'templates/email/ai-generated-response-fallback-template.txt',
    name: 'AI Generated Response',
    subject: AI_RESPONSE_FALLBACK_SUBJECT,
    message: AI_RESPONSE_FALLBACK_MESSAGE,
  },
];
